import { Link, useMatches } from '@remix-run/react'
import React from 'react'
import { EXTERNAL_LINK_PROPS } from '#app/shared/lib/external-links.ts'

type headerNavProps = {
  headerNavItems: {
    name: string
    path: string
    Icon?: React.ReactNode
  }[]
  isActive: (item: { path: string }) => boolean
  variant?: 'dark' | 'light'
}

export default function HeaderNav({
  headerNavItems,
  isActive,
  variant = 'dark',
}: headerNavProps) {
  const matches = useMatches()
  const pathName = matches[matches.length - 1]?.pathname
  return (
    <div
      className={`
        flex items-center justify-center gap-5

        xl:gap-9
      `}
    >
      {headerNavItems.map((item) => {
        // Algunas entradas apuntan a apps externas (p. ej. "Encarga un coche"),
        // que no las puede resolver el router de Remix.
        const isExternal = item.path.startsWith('http')
        const className = `
          flex items-center gap-1.5 text-subtitle1-medium

          hover:text-primary-600

          ${pathName === `/${item.path}/` ? 'text-primary-600' : ''}
          ${variant === 'light' ? 'text-white' : 'text-neutral-900'}
          ${isActive(item) ? `!text-primary-600` : ``}
        `
        const content = (
          <>
            <span className="text-nowrap text-[1rem]">{item.name}</span>
            {item.Icon && (
              <span className={`text-neutral-500`}>{item.Icon}</span>
            )}
          </>
        )

        return isExternal ? (
          <a
            key={item.path}
            href={item.path}
            className={className}
            {...EXTERNAL_LINK_PROPS}
          >
            {content}
          </a>
        ) : (
          <Link
            key={item.path}
            to={`${item.path}`}
            className={className}
            prefetch="intent"
          >
            {content}
          </Link>
        )
      })}
    </div>
  )
}
